import { Modal } from "react-bootstrap";
import ReactTooltip from "react-tooltip";

function DownloadModal({ showModal, setShowModal, downloadFromValue, setDownloadFromValue, downloadToValue, setDownloadToValue, dataCount, downloadRangeFilter, showNote = false }) {
  return (
    <Modal
      className="trademo-impexpmodal"
      centered
      show={showModal}
      onHide={() => {
        setShowModal(false);
      }}
      animation={false}>
      <Modal.Header closeButton>
        <Modal.Title>Download Excel </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row m-0 ">
          <div className="col-6 p-0">
            <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="bottom" />
            <span className="label-value line-height-32">Select records by S.No</span>
          </div>
          <div className="col-6 p-0">
            <div className="row m-0">
              <div className="col-5 pr-0">
                <input name="advanceSearchEntireBillLading" className="download-input-field" placeholder="From" type="number" value={downloadFromValue} onChange={(e) => setDownloadFromValue(e.target.value)} />
              </div>
              {/* downloadFromValue:1,
    downloadToValue:100, */}

              <div className="col-2">
                <span className="label-value line-height-32">to</span>
              </div>
              <div className="col-5 pr-0">
                <input name="advanceSearchEntireBillLading" className="download-input-field" placeholder="To" type="number" value={downloadToValue} onChange={(e) => setDownloadToValue(e.target.value > dataCount ? dataCount : e.target.value)} />
              </div>
            </div>
            {downloadFromValue && !!downloadToValue && downloadToValue - downloadFromValue > 9999 ? (
              <div className="py-3">
                <span className="error">*You can select maximum of 10000 at a time.</span>
              </div>
            ) : (
              <div className="py-3"></div>
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {showNote && (
          <div className="col-8 p-0 m-0">
            <span className="download-credit-label">*You can select maximum of 500 at a time.</span>
          </div>
        )}
        {/* {!!this.state.downloadShipmentCount && this.state.downloadShipmentCount > 0 ? <span className="mr-auto">Emailing {this.state.downloadShipmentCount} shipments.</span> : <></>} */}

        <div className="col-4 p-0 m-0 d-flex justify-content-end">
          <button type="button" className="btn btn-outline-secondary trademo-outline-btn btn-sm mr-2" onClick={() => setShowModal(false)}>
            Cancel
          </button>
          <button onClick={() => downloadRangeFilter()} type="button" disabled={downloadFromValue === "" || downloadToValue === "" || downloadToValue - downloadFromValue > 9999 ? true : false} className="btn btn-primary btn-sm trademo-new-btn">
            Email
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default DownloadModal;
